import React, { Component, } from 'react';
// react modal for create/edit
import ReactModal from 'react-modal';
// prop types
import PropTypes from 'prop-types';
// react redux connect
import { connect } from 'react-redux';
// lodash is empty
import { isEmpty } from 'lodash';
// styled components
import styled from 'styled-components';
// JS Moment
import moment from 'moment';
// js barcode for creating coupons
import JsBarcode from 'jsbarcode';

// icon imports
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UpIcon from '@material-ui/icons/ArrowUpward';
import DownIcon from '@material-ui/icons/ArrowDownward';

// moment utils for MuiPickersUtilsProvider
import MomentUtils from '@date-io/moment';
// material ui pickers
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';

// other material UI imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  CircularProgress,
  Button,
  IconButton,
  Grid,
  FormControlLabel,
  withStyles,
} from '@material-ui/core';

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
  UploadButton
} from "../../components";

// reducer imports
import {
  loadCoupon,
  setCoupons,
  updateCoupons,
  createBarcode,
} from './reducer/actions';

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// custom table cell for table of Coupons
const CustomTableCell = withStyles(theme => ({
  head: {
    fontSize: 16,
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '230px',
  },
}))(TableCell);

// last set of styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflow: 'auto',
  },
  table: {
    maxWidth: 730,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// The public is in danger!
// My EVENING'S in danger!

// class declaration
class CouponList extends Component {

  // constructor
  constructor (props) {
    super(props);
    this.state = {
      deal: '', // description of coupon's offer
      expirationDate: moment().add(1, 'week'), // when the coupon expires
      startDate: moment(), // when the coupon becomes available
      barcode: '', // the numerical barcode on the coupon
      barcodeImage: null, // the actual, well, bar code
      showModal: false, // whether the modal is on
      isEditing: false, // whether editing or creating
      id: null, // uuid of coupon being edited
      neverExpires: false, // no expiration date if true
      redemptionsAllowed: 1, // number of times a user can redeem a coupon
      unlimitedRedemptions: false, // bool to allow for unlimited redemptions
      redemptions: null, // who has redeemed this coupon
    };
    //binds
    this.initEditCoupon = this.initEditCoupon.bind(this);
    this._onCreateNewCoupon = this._onCreateNewCoupon.bind(this);
    this._onDeleteCoupon = this._onDeleteCoupon.bind(this);
    this.uploadBarcode = this.uploadBarcode.bind(this);
  }

  // when loading in, load coupons
  componentDidMount() {
    this.props.loadCoupon(this._onSuccess.bind(this), this._onError.bind(this));
    if (this.props.allCoupon) {
      this.props.setCoupons(
        this.props.allCoupon,
        this._onSuccess.bind(this),
        this._onError.bind(this)
      );
    }
  }

  // creates a barcode at random
  generateBarcode(){
    let code = this.generateCode();
    this.setState({barcode: code});
  }

  // handles click of "Generate Defined Barcode" button
  handleGenerateDefinedBarcode(){
    JsBarcode("#barcode", this.state.barcode, {format: "UPC"});
    this.uploadBarcode();
  }

  // uploads and updates barcodes
  uploadBarcode() {
    // get the barcode
    let barcode = document.querySelector('#barcode')
    barcode = String(barcode.src);
    barcode = barcode.replace("data:image/png;base64,", "");
    this.props.createBarcode(this.state.id, barcode,
      this.barcodeError.bind(this),
      this.barcodeSuccess.bind(this),
    );
  }

  // generates a string of numbers 11 characters long that can start with 0
  generateCode() {
    // upper limit is 1,000,000,000,000
    var max = Math.pow(10, 12);
    // lower limit is 100,000,000,000
    var min = max/10;
    // ensures number is at least Min
    var number = Math.floor( Math.random() * (max - min + 1) ) + min;
    // cut off first digit and return
    return String(number).substring(1);
  }

  // on successful create/edit, close modal
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // on unsuccessful create/edit, close modal and log error
  _onError (error) {
    this.setState({ showModal: false });
    console.log(error);
  }

  // on successful creation of barcode
  barcodeSuccess (image) {
    this.setState({ barcodeImage: image });
  }

  // creation unsuccessful
  barcodeError (error) {
    this.setState({ barcodeImage: null });
    alert('Could not create barcode! Please try again.');
  }

  // remove a coupon from the array
  _onDeleteCoupon (id) {
    var coupons = this.props.allCoupon;
    coupons.splice(id, 1);
    this.props.setCoupons(
      coupons,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // called when opening the Modal to Edit a Coupon
  initEditCoupon (id) {
    const { allCoupon } = this.props;
    // get appropriate coupon
    const curCoupon = allCoupon[id];
    // and then set the state of the modal accordingly
    this.setState({
      id: id,
      deal: curCoupon.deal,
      startDate: curCoupon.startDate,
      expirationDate: curCoupon.expirationDate,
      barcode: curCoupon.barcode,
      barcodeImage: curCoupon.barcodeImage || null,
      image: curCoupon.image || null,
      neverExpires: curCoupon.neverExpires || false,
      redemptionsAllowed: curCoupon.redemptionsAllowed >= 0 ?
        curCoupon.redemptionsAllowed : 1,
      isEditing: true,
      showModal: true,
      redemptions: curCoupon.redemptions || null,
    });
  }

  // called when the Edit button is pressed
  _onEditCoupon (id) {
    var coupons = this.props.allCoupon;
    const data = {
      deal: this.state.deal,
      startDate: moment(this.state.startDate).format(),
      expirationDate: moment(this.state.expirationDate).format(),
      barcode: this.state.barcode,
      barcodeImage: this.state.barcodeImage,
      image: this.state.image,
      neverExpires: this.state.neverExpires || false,
      redemptionsAllowed: this.state.redemptionsAllowed >= 0 ?
        this.state.redemptionsAllowed : 1,
      redemptions: this.state.redemptions,
      unlimitedRedemptions: this.state.redemptionsAllowed === 0 ?
        true : false,
      id: id
    };
    coupons[id] = data;
    this.props.updateCoupons(
      coupons,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // called on pressing Create on the modal
  _onCreateNewCoupon () {
    var coupons = this.props.allCoupon;
    var obj = {
      deal: this.state.deal,
      startDate: moment(this.state.startDate).format(),
      expirationDate: moment(this.state.expirationDate).format(),
      barcode: this.state.barcode,
      barcodeImage: this.state.barcodeImage,
      image: this.state.image,
      neverExpires: this.state.neverExpires,
      redemptionsAllowed: this.state.redemptionsAllowed >= 0 ?
        this.state.redemptionsAllowed : 1,
      unlimitedRedemptions: this.state.redemptionsAllowed === 0 ?
        true : false,
    };
    coupons.push(obj);
    this.props.updateCoupons(
      coupons,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );

  }

  // on showing the modal to Create a new coupon,
  // all the modal fields should be blank
  _onShowModal () {
    this.setState({
      deal: '',
      startDate: moment(),
      expirationDate: moment().add(1, 'week'),
      barcode: '',
      barcodeImage: '',
      image: null,
      showModal: true,
      isEditing: false,
      id: null,
      neverExpires: false,
      unlimitedRedemptions: false,
      redemptions: null,
    });
  }

  // close the modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // rearrange coupons upon clicking the Up button under Options
  _moveCouponUp(id) {
    if (id === 0) {
      return;
    }
    let currentCoupon = this.props.allCoupon;

    let temp = currentCoupon[id];
    currentCoupon[id] = currentCoupon[id -1];
    currentCoupon[id - 1] = temp;
    currentCoupon[id].id = id;
    currentCoupon[id - 1].id = id - 1;

    this.props.updateCoupons(
      currentCoupon,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // same, but upon clicking Down
  _moveCouponDown(id) {
    let currentCoupon = this.props.allCoupon;
    if (id >= currentCoupon.length - 1) {
      return;
    }

    let temp = currentCoupon[id];
    currentCoupon[id] = currentCoupon[id + 1];
    currentCoupon[id + 1] = temp;
    currentCoupon[id].id = id;
    currentCoupon[id + 1].id = id + 1;

    this.props.updateCoupons(
      currentCoupon,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // render all backend Coupons
  renderCouponList(coupons){
    const { classes } = this.props;
     return (coupons.map((n, id) => {
      return (
        <TableRow key={id} className={classes.row}>
          {/* attached Image and deal description */}
          <CustomTableCell>
            {/* image */}
            <div
              style={{
                width: 100,
                height: 40,
                backgroundColor: '#ccc',
                backgroundImage: `url("${n.image}")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%'
              }}
            />
            <br />
            {/* description */}
            {n.deal}
          </CustomTableCell>
          {/* Coupon barcode and expiration date*/}
          <CustomTableCell>
            {<img height={40} width={80} src={n.barcodeImage} alt={'barcode'}/>}
            <br />
            {'Expr: '}
            {moment(n.expirationDate).format('MM/DD/YY')}
          </CustomTableCell>
          {/* Edit, Delete, Move Up, and Move Down buttons */}
          <CustomTableCell style={{flexDirection: 'row'}}>
            <div style={{flexDirection: 'column'}}>
              {/* Edit button */}
              <IconButton tooltip="Edit Coupon"
                onClick={(e) => {this.initEditCoupon(id)}}>
                <EditIcon />
              </IconButton>
              {/* Move Up button */}
              <IconButton tooltip="Move Coupon up"
                onClick = {(e) => {this._moveCouponUp(id)}}>
                <UpIcon />
              </IconButton>
            </div>
            <div style={{flexDirection: 'column'}}>
              {/* Delete button */}
              <IconButton tooltip="Delete Coupon"
                onClick={(e) => {this._onDeleteCoupon(id)}}>
                <DeleteIcon />
              </IconButton>
              {/* Move Down button */}
              <IconButton tooltip="Move Coupon down"
                onClick = {(e) => {this._moveCouponDown(id)}}>
                <DownIcon />
              </IconButton>
            </div>
          </CustomTableCell>
        </TableRow>
        );
      }
    ))
  }

  // Create/Edit Coupon Modal
  couponModal() {
    // if modal has not been turned on, return null
    if (!this.state.showModal) {
      return null;
    }
    return (
      <ReactModal
        isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Coupon' : 'Add Coupon'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        <ModalHeader>
          {this.state.isEditing ? 'Edit Coupon' : 'Add Coupon'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* What the coupon can be redeemed for */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Deal Description'
                id='deal'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.deal,
                  onChange: (e)=>this.setState({ deal: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Coupon Image upload */}
            <ItemGrid xs={6}
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
              }}>
              <UploadButton
                storage="friends"
                value={this.state.image}
                onUploadComplete={uri => this.setState({ image: uri })}
              />
            </ItemGrid>
            {/* Select Coupon start date */}
            <ItemGrid xs={6}>
              <DatePicker
                label={'Start Date'}
                value={this.state.startDate}
                onChange={(date) => {this.setState({ startDate: date })}}
              />
            </ItemGrid>
            {/* Select Coupon expiration date */}
            <ItemGrid xs={6}>
              <DatePicker
                disabled={this.state.neverExpires}
                label={'Expiration Date'}
                value={this.state.expirationDate}
                onChange={(date) => {this.setState({ expirationDate: date })}}
              />
            </ItemGrid>
            {/* Checkbox if a coupon never expires */}
            <ItemGrid xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.neverExpires}
                    onChange={(e,c) => this.setState({neverExpires:c})}
                  />
                }
                style={{marginLeft: 20, marginTop: 30}}
                label='Never Expires?'
              />
            </ItemGrid>
            {/* Number of times coupon can be used */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='# of Uses (put 0 for Unlimited)'
                id='numRedemptions'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.redemptionsAllowed,
                  onChange: (e)=>this.setState({
                    redemptionsAllowed:
                      e.target.value < 0 ? 0 : Number(e.target.value)
                  }),
                  type: 'number',
                  disabled: this.state.unlimitedRedemptions,
                }}
              />
            </ItemGrid>
            {/* barcode related functions */}
            <ItemGrid xs={6}>
              {/* allow user to input a barcode or randomly generate one */}
              <CustomInput
                labelText='UPC(A) Code (11 numbers)'
                id='UPCCode'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.barcode,
                  onChange: (e)=>this.setState({ barcode: e.target.value })
                }}
              />
              {/* create barcode automatically */}
              <Button
                variant='raised'
                style={{
                  backgroundColor: '#E5E5E5',
                  textAlign: 'center',
                  width: '90%',
                  marginBottom: 5,
                }}
                onClick={(e) => {this.generateBarcode()}}
              >
                Auto-Generate UPC Code
              </Button>
              {/* make the barcode image */}
              <Button
                variant='raised'
                style={{
                  backgroundColor: '#E5E5E5',
                  textAlign: 'center',
                  width: '90%'
                }}
                onClick={(e) => {this.handleGenerateDefinedBarcode()}}
              >
                Create Barcode Image
              </Button>
            </ItemGrid>
            {/* Display the barcode image */}
            <ItemGrid xs={6}>
              <div style={{height: 150}}>
                <img id="barcode"
                  alt={' '}
                  src={this.state.barcodeImage}
                />
              </div>
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          {/* Confirm create/edit */}
          <Button variant='raised'
            primary={true}
            onClick={(e) =>
              {this.state.isEditing ?
                this._onEditCoupon(this.state.id)
                : this._onCreateNewCoupon()} }>
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          {/* or just cancel */}
          <Button variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) =>
              {this.setState({ isEditing: false, showModal: false })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // render function
  render() {
    // classes contains the Classes styles from above
    const { allCoupon, classes, isLoading } = this.props;

    // if still loading, show loading swirly and return
    if (isLoading) {
      return (
        <TableRow>
          <TableCell colSpan={6}>
            <CircularProgress />
          </TableCell>
        </TableRow>
      )
    }

    // if done loading, return table
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <RegularCard
        cardTitle="Coupons"
        cardSubtitle={
          <Button style={{background: '#E5e5e5'}}
            onClick={this._onShowModal.bind(this)}
          >
            Add Coupon
          </Button>
        }
        content={
          <Table className={classes.table}>
            <TableHead>
              {/*Top row of content descriptors */}
              <TableRow>
                {/* The deal offered by the coupon */}
                <CustomTableCell>
                  Deal
                </CustomTableCell>
                {/* Show item Barcode */}
                <CustomTableCell>
                  Barcode
                </CustomTableCell>
                {/* Option buttons */}
                <CustomTableCell>
                  Options
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* if coupons have loaded, show them */}
              {!isLoading && !isEmpty(allCoupon) ?
                this.renderCouponList(allCoupon)
                : null
              }
              {/* bottom row add coupon button */}
              <TableRow>
                <TableCell colSpan={6}>
                  <Button style={{background: '#E5e5e5'}}
                    onClick={this._onShowModal.bind(this)}>
                    Add Coupon
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
            {/* end of page table, start of Create/Edit modal */}
            { this.couponModal() }
          </Table>
          }
      />
      </MuiPickersUtilsProvider>
    );
  }
} // end of class declaration

CouponList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    allCoupon: state.couponReducer.coupon,
    isLoading: state.couponReducer.isLoading
  }
};

const mapDispatchToProps = {
  loadCoupon,
  setCoupons,
  updateCoupons,
  createBarcode,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CouponList));
